var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
let SelectMultipleNodeInput = class SelectMultipleNodeInput extends LitElement {
    onInputChange(event) {
        const selectedValues = event.detail.value;
        // Update the input value with the selected values
        this.input.value = selectedValues;
        // Dispatch custom event with the updated input
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: { key: this.key, input: this.input },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
        <select-multiple-input
            .value=${this.input?.value || []}
            .options=${this.input?.options || []}
            .placeholder=${this.input?.placeholder || msg('Select options...', { id: 'form.placeholder.selectOptions', desc: 'Multiple select placeholder' })}
            size="small"
            @select-multiple-change=${this.onInputChange}
        ></select-multiple-input>
    `;
    }
};
SelectMultipleNodeInput.styles = css `
      /* Styles are handled by the select-multiple-input component */
    `;
__decorate([
    property({ type: String })
], SelectMultipleNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], SelectMultipleNodeInput.prototype, "input", void 0);
SelectMultipleNodeInput = __decorate([
    localized(),
    customElement('select-multiple-node-input')
], SelectMultipleNodeInput);
export { SelectMultipleNodeInput };
//# sourceMappingURL=SelectMultipleNodeInput.js.map